import { render, staticRenderFns } from "./LessonAdmin.vue?vue&type=template&id=514b533c&"
import script from "./LessonAdmin.vue?vue&type=script&lang=ts&"
export * from "./LessonAdmin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('514b533c', component.options)
    } else {
      api.reload('514b533c', component.options)
    }
    module.hot.accept("./LessonAdmin.vue?vue&type=template&id=514b533c&", function () {
      api.rerender('514b533c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/courses/CoursePage/components/LessonAdmin.vue"
export default component.exports